<template>
	<div class="member-menu">
		<div class="menu-each">
			<div class="menu-each-title">
				<img src="../../assets/common/icons/mySchedule.png" />
				<span v-if="loginUserInfo.role == 1 || loginUserInfo.role == 2">我的日程</span>
				<span v-else>我创建的</span>
			</div>
			<div class="menu-each-memberList">
				<div class="memberList-each" @click="selectViewUser('')">
					<div class="memberList-each-info">
						<img v-if="loginUserInfo.headImg" :src="loginUserInfo.headImg" />
						<img v-else src="../../assets/common/userHeadImg_Default.png" />
						<span>{{loginUserInfo.name}}</span>
					</div>
					<img v-if="viewUserId == userId" class="member-isSelected"
						src="../../assets/common/icons/isSelected.png" />
				</div>
			</div>
		</div>
		<div class="menu-each" v-if="memberList.length > 0">
			<div class="menu-each-title">
				<img src="../../assets/common/icons/scheduleIcon_blue.png" />
				<span>人员管理</span>
			</div>
			<div class="menu-each-memberList">
				<div class="memberList-each" v-for="(item, index) in memberList" :key="index"
					@click="selectViewUser(item, index)">
					<div class="memberList-each-info">
						<img v-if="item.headImg" :src="item.headImg" />
						<img v-else src="../../assets/common/userHeadImg_Default.png" />
						<span>{{item.name}}</span>
					</div>
					<img v-if="item.isSelected" class="member-isSelected"
						src="../../assets/common/icons/isSelected.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			memberList: { //人员管理列表
				type: Array,
				default: []
			},
			userId: { //用户Id
				type: Number,
				default: -1
			},
			viewUserId: { //查看的用户Id
				type: Number,
				default: -1
			}
		},
		data() {
			return {
				loginUserInfo: {}, //登录用户信息
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				that.$bus.$on('getLoginUserInfo', (loginUserInfo) => {
					that.loginUserInfo = loginUserInfo;
				})
			})
		},
		methods: {
			//点击选择要查看的用户日程
			selectViewUser(userInfo, index) {
				let that = this;
				that.memberList.forEach((item, index) => {
					item.isSelected = false;
				});
				if (index || index == 0) {
					that.memberList[index].isSelected = true;
				}
				that.$bus.$emit("selectViewUser", userInfo);
			},
		},
	}
</script>

<style lang="scss">
	.member-menu {
		background-color: #E8EFFF;
		min-height: 100%;
		box-sizing: border-box;

		.menu-each {
			.menu-each-title {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;

				img {}

				span {
					font-weight: 400;
					color: #333333;
				}
			}

			.menu-each-memberList {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;

				.memberList-each {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					cursor: pointer;

					.memberList-each-info {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: flex-start;

						img {}

						span {
							font-weight: 400;
							color: #333333;
						}
					}

					.member-isSelected {}
				}
			}
		}
	}

	@media screen and (min-width: 1024px) {
		.member-menu {
			width: 182px;
			padding: 14px;

			.menu-each {
				.menu-each-title {
					img {
						width: 27px;
						height: 27px;
						margin: 0 10px 0 0;
					}

					span {
						font-size: 16px;
					}
				}

				.menu-each-memberList {
					margin: 0 0 23px;

					.memberList-each {
						.memberList-each-info {
							margin: 12px 0 0;

							img {
								width: 36px;
								height: 36px;
								margin: 0 13px 0 0;
							}

							span {
								font-size: 14px;
							}
						}

						.member-isSelected {
							width: 21px;
							height: 21px;
							margin: 12px 0 0;
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.member-menu {
			width: 300px;
			padding: 24px;

			.menu-each {
				.menu-each-title {
					img {
						width: 44px;
						height: 44px;
						margin: 0 16px 0 0;
					}

					span {
						font-size: 26px;
					}
				}

				.menu-each-memberList {
					margin: 0 0 40px;

					.memberList-each {
						.memberList-each-info {
							margin: 20px 0 0;

							img {
								width: 60px;
								height: 60px;
								margin: 0 20px 0 0;
							}

							span {
								font-size: 24px;
							}
						}

						.member-isSelected {
							width: 34px;
							height: 34px;
							margin: 20px 0 0;
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>